// Quality Effectiveness — Initial RPN vs New RPN per closed FMEA.
// 14 closed FMEAs across BMW supplier cluster, ordered chronologically (oldest → newest).
// Averages: Initial ≈ 312 · New ≈ 89 · Reduction ≈ 71 %.

const RAW = [
  { id: "FMEA-0788", supplier: "Inteva",   initial: 420, current: 96 },
  { id: "FMEA-0795", supplier: "Leoni",    initial: 378, current: 112 },
  { id: "FMEA-0802", supplier: "DB Sch.",  initial: 336, current: 84 },
  { id: "FMEA-0809", supplier: "Rehau",    initial: 280, current: 72 },
  { id: "FMEA-0817", supplier: "Hörmann",  initial: 252, current: 75 },
  { id: "FMEA-0824", supplier: "Inteva",   initial: 360, current: 108 },
  { id: "FMEA-0831", supplier: "LPR",      initial: 200, current: 60 },
  { id: "FMEA-0837", supplier: "BMW JIS",  initial: 245, current: 56 },
  { id: "FMEA-0844", supplier: "Leoni",    initial: 384, current: 110 },
  { id: "FMEA-0855", supplier: "Leoni",    initial: 378, current: 130 },
  { id: "FMEA-0862", supplier: "DB Sch.",  initial: 252, current: 72 },
  { id: "FMEA-0868", supplier: "Inteva",   initial: 350, current: 100 },
  { id: "FMEA-0875", supplier: "Hörmann",  initial: 224, current: 70 },
  { id: "FMEA-0891", supplier: "Inteva",   initial: 308, current: 101 },
];

// rolling 3-point average reduction (%) — used for the trendline overlay
function rollingAvgReduction(rows, window = 3) {
  return rows.map((r, i) => {
    const lo = Math.max(0, i - window + 1);
    const slice = rows.slice(lo, i + 1);
    const r1 =
      slice.reduce((s, x) => s + (x.initial - x.current) / x.initial, 0) /
      slice.length;
    return Math.round(r1 * 1000) / 10; // one decimal
  });
}

const rolling = rollingAvgReduction(RAW);

export const qualityEffectivenessRows = RAW.map((r, i) => ({
  ...r,
  reduction: Math.round(((r.initial - r.current) / r.initial) * 100),
  rollingReduction: rolling[i],
}));

const avg = (arr, k) => Math.round(arr.reduce((s, x) => s + x[k], 0) / arr.length);

export const qualityEffectivenessStats = {
  count: RAW.length,
  avgInitial: avg(RAW, "initial"), // 312
  avgNew: avg(RAW, "current"), // 89
  avgReduction: Math.round(
    RAW.reduce((s, r) => s + (r.initial - r.current) / r.initial, 0) /
      RAW.length *
      100
  ), // 71
};

export const qualityEffectivenessInsight =
  "Corrective actions delivered an average 71% RPN reduction across 14 closed FMEAs — quality loop is working. Inteva and Leoni clusters drive 60% of remaining residual RPN; target the next cycle there.";
